/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FailureListItemVm,
    FailureListItemVmFromJSON,
    FailureListItemVmFromJSONTyped,
    FailureListItemVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface FailureListItemVmPaginatedSearchResponse
 */
export interface FailureListItemVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<FailureListItemVm>}
     * @memberof FailureListItemVmPaginatedSearchResponse
     */
    items?: Array<FailureListItemVm> | null;
    /**
     * 
     * @type {number}
     * @memberof FailureListItemVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureListItemVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureListItemVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureListItemVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureListItemVmPaginatedSearchResponse
     */
    size?: number;
}

export function FailureListItemVmPaginatedSearchResponseFromJSON(json: any): FailureListItemVmPaginatedSearchResponse {
    return FailureListItemVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function FailureListItemVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureListItemVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(FailureListItemVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function FailureListItemVmPaginatedSearchResponseToJSON(value?: FailureListItemVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(FailureListItemVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


